<template>
  <div class="be-wrapper be-error be-error-404">
    <navbar></navbar>
        <div class="error-container">
          <div class="error-number">404</div>
          <div class="error-description">Whoops, something went wrong!</div>
          <div class="error-goback-text">Please try again or contact us if the problem continues.</div>
          <div class="error-goback-button"><a href="/" class="btn btn-xl btn-primary">Let's go home</a></div>
        </div>

  </div>
</template>


<script>

import Navbar from './navbar/Navbar'

export default {
  components: {
    Navbar,
  },
}
</script>

<style lang="scss" scope>
</style>



// WEBPACK FOOTER //
// NotFound.vue?3068c3e4